import type { StaffFeatureId } from "@wallyo/contracts/actions";
import { featureName, t } from "../../i18n";

/** A part of a screen that needs a feature this person lacks: what it needs, and that their roles don't have it. */
export function FeatureLock({
  lead,
  feature,
  roles,
}: {
  lead: string;
  feature: StaffFeatureId;
  roles: readonly string[];
}) {
  return (
    <div className="denied" role="status">
      🔒 {lead} <b>{featureName(feature)}</b>.
      <br />
      {t("customers.lockedRoles", { roles: roles.join(", ") })}
    </div>
  );
}
